import React from "react";
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";

const APP_STORE = "https://apps.apple.com/app/id6758252728";
const GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=com.hyp.app";

const cream = "#F5F0E8";
const purple = "#8B5CF6";
const darkBg = "#1a1025";
const mutedCream = "rgba(245,240,232,0.6)";

const programs = [
  { name: "Quit Smoking", subtitle: "Break free for good" },
  { name: "Reduce Anxiety", subtitle: "Find your calm" },
  { name: "Build Confidence", subtitle: "Own every room" },
  { name: "Better Sleep", subtitle: "Rest deeply" },
  { name: "Weight Management", subtitle: "Reshape your relationship with food" },
  { name: "Focus & Productivity", subtitle: "Sharpen your mind" },
  { name: "Pain Management", subtitle: "Reframe your experience" },
  { name: "Break Bad Habits", subtitle: "Replace what isn't working" },
];

const features = [
  { title: "Progress Tracking", desc: "Build streaks and watch your transformation unfold" },
  { title: "Daily Reminders", desc: "Gentle nudges to keep your practice consistent" },
  { title: "Privacy-First", desc: "All data stored locally on your device" },
];

export default function HypLanding() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: darkBg, color: cream }}>
      {/* Nav */}
      <nav className="max-w-7xl mx-auto px-4 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="/AppIcon012526.png" alt="HYP" className="w-10 h-10 rounded-xl" />
          <span className="text-xl font-bold" style={{ color: cream }}>HYP</span>
        </Link>
        <a href={APP_STORE} className="text-sm font-medium px-5 py-2 rounded-full" style={{ backgroundColor: purple, color: "#fff" }}>
          Download
        </a>
      </nav>

      {/* Hero */}
      <section className="max-w-7xl mx-auto px-4 py-16 md:py-24 text-center">
        <img src="/AppIcon012526.png" alt="HYP" className="w-28 h-28 rounded-3xl mx-auto mb-8 shadow-2xl" />
        <h1 className="text-4xl md:text-6xl font-bold mb-4" style={{ color: cream }}>HYP — Daily Hypnosis</h1>
        <p className="text-xl md:text-2xl mb-10" style={{ color: mutedCream }}>Change your habits in 10 minutes a day</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a href={APP_STORE} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-white font-medium" style={{ backgroundColor: purple }}>
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            App Store
          </a>
          <a href={GOOGLE_PLAY} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-white font-medium" style={{ backgroundColor: purple }}>
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/></svg>
            Google Play
          </a>
        </div>
        <div className="inline-block p-4 rounded-2xl" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
          <QRCodeSVG value={APP_STORE} size={140} bgColor="transparent" fgColor={cream} />
          <p className="text-xs mt-2" style={{ color: mutedCream }}>Scan to download</p>
        </div>
      </section>

      {/* How It Works — Flowing Steps */}
      <section className="py-20" style={{ backgroundColor: "rgba(139,92,246,0.04)" }}>
        <div className="max-w-3xl mx-auto px-4">
          <div className="space-y-0">
            {[
              "Choose a habit you would like to start or stop",
              "Reinforce this habit daily",
              "Build a better life",
            ].map((text, i) => (
              <div key={i} className="flex items-center gap-6 py-6" style={{ borderBottom: i < 2 ? "1px solid rgba(139,92,246,0.12)" : "none" }}>
                <div className="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center" style={{ backgroundColor: purple }}>
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
                    {i === 0 && <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />}
                    {i === 1 && <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182" />}
                    {i === 2 && <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />}
                  </svg>
                </div>
                <p className="text-xl md:text-2xl font-medium" style={{ color: cream }}>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{ color: cream }}>Simple by Design</h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {features.map((f, i) => (
            <div key={i} className="text-center px-4">
              <div className="w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: "rgba(139,92,246,0.15)" }}>
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: purple }} />
              </div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: cream }}>{f.title}</h3>
              <p className="text-sm" style={{ color: mutedCream }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Programs */}
      <section className="py-16" style={{ backgroundColor: "rgba(139,92,246,0.04)" }}>
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{ color: cream }}>Programs</h2>
          <p className="text-center mb-12" style={{ color: mutedCream }}>Behavior change for what matters most</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {programs.map((p, i) => (
              <div key={i} className="p-5 rounded-2xl" style={{ backgroundColor: "rgba(139,92,246,0.08)", border: "1px solid rgba(139,92,246,0.12)" }}>
                <p className="font-semibold text-sm mb-1" style={{ color: cream }}>{p.name}</p>
                <p className="text-xs" style={{ color: mutedCream }}>{p.subtitle}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="max-w-7xl mx-auto px-4 py-16 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: cream }}>Start Free</h2>
        <p className="text-lg mb-8" style={{ color: mutedCream }}>5 sessions free. No credit card required.</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 max-w-2xl mx-auto">
          {[
            { label: "Monthly", price: "$4.99/mo" },
            { label: "Yearly", price: "$39.99/yr", badge: "Best Value" },
            { label: "Lifetime", price: "$74.99" },
          ].map((p, i) => (
            <div key={i} className="w-full sm:w-1/3 p-6 rounded-2xl relative" style={{ backgroundColor: "rgba(139,92,246,0.1)", border: i === 1 ? `2px solid ${purple}` : "1px solid rgba(139,92,246,0.2)" }}>
              {p.badge && <span className="absolute -top-3 left-1/2 -translate-x-1/2 text-xs font-semibold px-3 py-1 rounded-full text-white" style={{ backgroundColor: purple }}>{p.badge}</span>}
              <p className="text-sm mb-1" style={{ color: mutedCream }}>{p.label}</p>
              <p className="text-2xl font-bold" style={{ color: cream }}>{p.price}</p>
            </div>
          ))}
        </div>
        <div className="mt-10">
          <a href={APP_STORE} className="inline-block px-8 py-4 rounded-xl text-white font-semibold text-lg" style={{ backgroundColor: purple }}>
            Download HYP Free
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 border-t" style={{ borderColor: "rgba(139,92,246,0.15)" }}>
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4 text-sm" style={{ color: mutedCream }}>
          <p>&copy; {new Date().getFullYear()} Plexys. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/hyp/privacy" className="hover:opacity-100 transition">Privacy Policy</Link>
            <Link to="/hyp/terms" className="hover:opacity-100 transition">Terms of Service</Link>
            <Link to="/" className="hover:opacity-100 transition">Plexys Home</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
